<!-- =========================================================================================
  File Name: CustomerDebtListFormSidebar.vue
  Description: Add New Data - Sidebar component
========================================================================================== -->
<i18n src="@/locales/modules/CustomerTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			setDialogHide =>
				handleCloseDialog(() => {
					initValues();
					setDialogHide();
				}, isFormDirty)
		"
		class="custom-dialog todo-list-form-sidebar"
		:visible.sync="isSidebarActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">{{ $t("StockCard") }}</h4>
		</div>
		<perfect-scrollbar ref="vueScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6">
				<!-- File -->

				<cbs-upload-ref title="Chọn tập tin để nạp dữ liệu vào hệ thống" :limit="1" accept=".xlsx, .xls" v-model="attachs" displayMode="input" />

				<div class="border-t-2 analysis-results">
					<h5 class="font-bold mb-4">{{ $t("AnalysisResults") }}</h5>
					<div class="bg-gray-6 p-5">
						<img v-if="!analysisResults" style="margin: 0 auto;" class="block" src="@/assets/images/cbs/nodata.png" alt="nodata" width="175" />
						<div v-else>
							<div v-for="(tr, idx) in analysisResults" :key="`analysisResults${idx}`" class="grid gap-2 grid-cols-2">
								<p>{{ tr.name }}</p>
								<p>{{ tr.value }}</p>
							</div>
						</div>
					</div>
					<p v-if="analysisResults && analysisResults.length > 0" class="mt-4">Tổng: Tạo mới được {{ analysisResults.length }} số liệu</p>
				</div>
			</div>
		</perfect-scrollbar>

		<div class="flex justify-center flex-wrap items-center" slot="footer">
			<vs-button :disabled="!(attachs && attachs.length > 0)" class="w-full sm:w-1/3 font-bold" @click.stop="submitData(true)">{{ $t("Actions.Save") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";
import customerGql from "@/http/requests/card/customer_gql";

export default {
	name: "StockCardForm",
	provide() {
		return { parentValidator: this.$validator };
	},
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	components: {
		CbsUploadRef
	},
	data() {
		return {
			isFormDirty: false,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			attachs: [],
			analysisResults: null
		};
	},
	watch: {
		isSidebarActive(val) {
			if (!val) return;
			this.initValues();
		},
		data: function(newVal, oldVal) {
			if (_.isEmpty(newVal) || newVal.id !== oldVal.id) {
				this.$nextTick(() => {
					if (this.$refs.vueScrollBar) {
						this.$refs.vueScrollBar.$el.scrollTop = 0;
					}
				});
			}
		},
		computedFormData: {
			handler: function(newVal) {
				this.isFormDirty = JSON.stringify(newVal) !== JSON.stringify(this.initFormData);
			},
			deep: true
		},
		attachs: {
			handler: function() {
				if (this.attachs && this.attachs.length > 0) {
					this.handlePreview(this.attachs[0].id);
				}
			},
			deep: true
		}
	},

	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		computedFormData() {
			return {
				attachs: this.attachs,
				analysisResults: this.analysisResults
			};
		},
		productsChoices() {
			return this.$store.state.customerManagement.showProducts;
		}
	},
	methods: {
		initValues() {
			this.attachs = null;
			this.analysisResults = null;
			this.isFormDirty = false;
			this.setInitFormData();
			this.$validator.reset();
		},
		setInitFormData() {
			this.$nextTick(() => {
				this.initFormData = {
					attachs: null,
					analysisResults: null
				};
			});
		},
		handleCreateOrUpdateSuccess(isCloseForm) {
			if (isCloseForm) {
				this.$emit("closeSidebar");
			}
			this.$emit("importDataSuccess");
			this.initValues();
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: `${this.$t("ImportFile")} ${this.$t("Successful").toLowerCase()} `
				}
			});
		},
		async handleCreateOrUpdateCard(dataObj, isCloseForm) {
			try {
				this.$vs.loading();
				let response;

				response = await customerGql.importProductQuantity(dataObj);
				response = JSON.parse(response);
				if (response && response.status) {
					this.handleCreateOrUpdateSuccess(isCloseForm);
				} else {
					this.$vs.notify({
						title: this.$t("UnSuccessful"),
						text: `${this.$t("ImportFile")} ${this.$t("UnSuccessful").toLowerCase()} `,
						color: "danger"
					});
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		submitData(isCloseForm = false) {
			this.$validator.validateAll().then(result => {
				if (result) {
					try {
						const dataObj = {
							file_upload: this.attachs[0].id,
							step: 2
						};
						this.handleCreateOrUpdateCard(dataObj, isCloseForm);
					} catch (error) {
						console.error(error);
					}
				}
			});
		},

		async handlePreview(file) {
			try {
				this.$vs.loading();
				const res = await customerGql.importProductQuantity({ file_upload: file, step: 1 });
				this.analysisResults = JSON.parse(res);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		}
	},
	created() {}
};
</script>
<style lang="scss" scoped>
.analysis-results {
	margin-top: 2rem;
	padding-top: 2rem;
	border-top: 0.5px solid #eeeeee;
}
</style>
